import { Box, Grid, Stack, Typography } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { DEFAULT_PROFILE_COMPLETION_OVERLAY } from "../../constants/adminSettings";

const getOverlayState = (settingValue) => {
  if (!settingValue || typeof settingValue !== "object") {
    return {
      enabled: DEFAULT_PROFILE_COMPLETION_OVERLAY.showProfileCompletionOverlay,
      overlayType: DEFAULT_PROFILE_COMPLETION_OVERLAY.overlayType,
    };
  }

  return {
    enabled: Boolean(settingValue.showProfileCompletionOverlay),
    overlayType:
      settingValue.overlayType === "forced" ? "forced" : "simple",
  };
};

export default function ShowProfileCompletionOverlaySettings({ settingValue }) {
  const { enabled, overlayType } = getOverlayState(settingValue);

  return (
    <Stack spacing={1} sx={{ p: 0, flex: 1, justifyContent: "center" }}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                mb: 0.5,
              }}
            >
              <AccountCircleOutlinedIcon
                sx={{
                  fontSize: "1rem",
                  color: enabled ? "success.main" : "text.disabled",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  fontSize: "0.7rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                Status
              </Typography>
            </Box>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                color: enabled ? "success.dark" : "text.secondary",
                fontSize: "0.8rem",
                textTransform: "uppercase",
              }}
            >
              {enabled ? "Enabled" : "Disabled"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                fontSize: "0.7rem",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: 0.5,
                mb: 0.5,
              }}
            >
              Overlay Type
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                color: "text.primary",
                fontSize: "0.8rem",
              }}
            >
              {overlayType === "forced" ? "Forced" : "Simple"}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
}
